<template>
  <main class="split-container">
    <div class="section split-container__left">
      <h2>Sign Up</h2>
      <hr class="ruler--white" />
      <p>To continue, you must create a free account.</p>
    </div>

    <div class="section split-container__right">
      <div class="breadcrumbs overflow-container">
        <router-link class="breadcrumbs__item" to="/">
          Home
        </router-link>
        <span class="breadcrumbs__slash">
          /
        </span>
        <span class="breadcrumbs__item">
          Sign Up
        </span>
      </div>

      <router-view />
    </div>
  </main>
</template>
